import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { Modal } from 'react-responsive-modal';
import { MasterMessage } from '../../../masters/masterMessages';
import Grid from '@mui/material/Grid';
import FieldSelect from '../../components/general/fields/fieldSelect';
import { listRoutesBlock } from '../../../routes/listRoutesBlock';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ButtonGeneral from '../../components/general/buttons/buttonGeneral';
import Save from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import FieldText from '../../components/general/fields/fieldText';
import {
    asyncPatchtBlockPage,
    asyncPostBlockPage,
} from '../../../services/blockPages.service';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import Loading from '../../components/general/loading/loading';

type Props = {
    open: boolean;
    onClose: (value: boolean) => void;
    saveLoad: (value: boolean) => void;
    idBlockPage?: string;
    blockPage?: any | undefined;
    loading: false | boolean;
};

const ModalBlockPages = ({
    open,
    onClose,
    saveLoad,
    idBlockPage,
    blockPage,
    loading,
}: Props) => {
    const {
        titleNew,
        messageNew,
        messageNewError,
        titleEdit,
        messageEditOk,
        messageEditError,
    } = MasterMessage.blokPages;

    const formik = useFormik({
        initialValues: {
            page: '',
            description: '',
        },
        validationSchema: Yup.object({
            page: Yup.string().required('La página es obligatoria'),
            description: Yup.string().required('La descripción es obligatoria'),
        }),
        onSubmit: async (formModalBlockPages) => {
            if (idBlockPage) {
                asyncPatchtBlockPage(idBlockPage, formModalBlockPages).then(
                    (body: any) => {
                        if (body?.items !== undefined) {
                            SwalCustomClass.fire({
                                text: messageEditOk,
                                icon: 'success',
                                iconColor: '#1d1d1d',
                            });
                        } else if (body?.errors !== undefined) {
                            SwalCustomClass.fire({
                                text: messageEditError,
                                icon: 'error',
                                iconColor: '#1d1d1d',
                            });
                        }
                    }
                );
            } else {
                const body: any = await asyncPostBlockPage(formModalBlockPages);
                if (body?.items !== undefined) {
                    SwalCustomClass.fire({
                        text: messageNew,
                        icon: 'success',
                        iconColor: '#1d1d1d',
                    });
                } else if (body?.errors !== undefined) {
                    SwalCustomClass.fire({
                        text: messageNewError,
                        icon: 'error',
                        iconColor: '#1d1d1d',
                    });
                }
            }
            onClose(false);
            saveLoad(true);
            formik.handleReset;
        },
    });

    useEffect(() => {
        if (idBlockPage && blockPage) {
            formik.values.page = blockPage.page;
            formik.values.description = blockPage?.description;
        }
    }, [idBlockPage, blockPage]);

    return (
        <Modal
            open={open}
            onClose={() => onClose(false)}
            closeOnOverlayClick={false}
            styles={{ modal: { maxWidth: '500px', minWidth: '40%' } }}
        >
            <Box>
                <Typography
                    color="primary"
                    component="h3"
                    sx={{
                        fontSize: { lg: 27, xs: 23 },
                        mt: { xs: 1.5, sm: 1.5, md: 1.5, lg: 0 },
                    }}
                >
                    {idBlockPage ? titleEdit : titleNew}
                </Typography>
                <hr />
                <Box mt={3} px={1}>
                    <Grid
                        container
                        spacing={{ xs: 2, md: 2 }}
                        columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                    >
                        {loading ? (
                            <Loading />
                        ) : (
                            <>
                                <Grid item xs={12}>
                                    <FieldSelect
                                        data={listRoutesBlock}
                                        label="Página"
                                        name="page"
                                        size="small"
                                        required={true}
                                        defineValue="name"
                                        touched={formik.touched.page}
                                        errors={formik.errors.page}
                                        value={formik.values.page}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FieldText
                                        label="Descripción"
                                        name="description"
                                        size="small"
                                        required={true}
                                        rows={3}
                                        touched={formik.touched.description}
                                        errors={formik.errors.description}
                                        value={formik.values.description}
                                        onChange={formik.handleChange}
                                    />
                                </Grid>
                            </>
                        )}
                        <Grid item xs={12} sx={{ textAlign: 'right' }}>
                            <ButtonGeneral
                                onClick={formik.handleSubmit}
                                startIcon={<Save color="secondary" />}
                                title="Guardar"
                                sx={{ mr: 1 }}
                            />
                            <ButtonGeneral
                                onClick={() => onClose(false)}
                                startIcon={<CancelIcon color="secondary" />}
                                title="Cancelar"
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Modal>
    );
};

export default ModalBlockPages;
